import { render } from "./EditLanguageContainer.vue?vue&type=template&id=11049065"
import script from "./EditLanguageContainer.vue?vue&type=script&lang=js"
export * from "./EditLanguageContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__